export default __webpack_public_path__ + "static/media/animedium-home.262d9920.png";